import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import importantElements from "../../assets/important-elements";

function WhatsImportantResults(props) {
    const {store, id, color} = props;
    const {resultStore, persistStore, interactionsStore} = store;

    const displayScore = (v) => {
        return v > 0 ? v : '-';
    };
    const displayResult = (v) => {
        if (!v || isNaN(v)) return '-';
        if (interactionsStore.mobileMode) {
            return Math.round(10 * v) / 10;
        }
        const imageSize = 32;

        const coins = [];
        for (let i = 0; i < v; i++) {
            coins.push({name: 'coin', frac: (i < v - 1) ? 1 : v - i});
        }
        return <Fragment>
            {coins.map(({name, frac}, i) => <div key={'coin_' + i} className={'wi-result-coin'} style={
                {
                    width: imageSize * frac,
                    height: imageSize,
                    transform: 'scale(0.75)',
                    backgroundImage: `url(img/coins/${name}.svg)`,
                    // backgroundPosition: ` ${imageSize * (1-frac)}px 0`
                }
            }/>)}
            <div className={'wi-result-text'}>{Math.round(10 * v) / 10}</div>
        </Fragment>;
    };
    return (
        <div className="WhatsImportantResults">
            <h3>You have had your say, thank you!</h3>
            <i>See what others are saying...</i>
            <div className="question">
                <table>
                    <tbody>
                    {importantElements.map((v, i) => <tr key={`op_${v.id}`}
                        // style={{background: color}}
                                                         className={'prog-item'}>
                        <td className={"text " + (persistStore.importantRanks.get(v.id).score > 0 ? 'active' : '')}>
                            {v.name}
                        </td>

                        <td>
                            <div className={'rank'}>
                                {displayScore(persistStore.importantRanks.get(v.id).score)}
                            </div>
                        </td>

                        <td className="bar">
                            {displayResult(resultStore.getAverageScore('important', v.id))}
                        </td>
                    </tr>)}
                    <tr>
                        <td className="space">

                        </td>
                        <td className="you">
                            You
                        </td>
                        <td className="others">
                            Others
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    );
}

export default observer(WhatsImportantResults);
